// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".login-2fa-form--layout {\n  display: flex;\n  width: 100%;\n  flex-direction: column;\n  gap: 10px;\n  min-height: 360px; }\n  .login-2fa-form--layout .login-2fa-form--actions {\n    margin-top: auto;\n    display: grid;\n    grid-template-columns: repeat(2, 1fr);\n    gap: 10px;\n    width: 100%; }\n", ""]);
// Exports
module.exports = exports;
